import axios from '../axios'

var SensorProvider = function () {
  return {
    async GetSensorInformation (railobjectId) {
      return axios.get('/switch/getSensorInformation?id=' + railobjectId)
    }
  }
}
export default new SensorProvider()



// WEBPACK FOOTER //
// ./src/providers/SensorProvider.js